module.exports = __webpack_public_path__ + "static/media/tutorial-7.75b1ae1f.jpg";